import { cookie as Cookie } from 'panda-global-locale';
import $i18n from '@alife/panda-i18n';

function setLocale(lang: string) {
  if (typeof window !== 'undefined' && getLocale() !== lang) {
    $i18n.setLang(lang);
    Cookie.set('giwsLang', lang, {
      maxAge: 24 * 30 * 60 * 60, // 最好设置 cookie 的过期时间, 不然 cookie 的过期时间就是 session 时间, 也就是关闭窗口的时间
      path: '/', // domain 为当前页面 domain
    });
    window.location.reload();
  }
}

// 根据地域设置默认语言
export const defaultLang = (host) => {
  let text = '';
  switch (host) {
    case 'giws.i4px.com':
      text = 'zh-CN';
      break;
    case 'giws.asia.i4px.com':
      text = 'ja-JP';
      break;
    default:
      text = 'en-US';
  }
  return text;
};

function getLocale() {
  if (!Cookie.get('giwsLang')) {
    Cookie.set('giwsLang', defaultLang(window.location.host), {
      maxAge: 24 * 30 * 60 * 60, // 最好设置 cookie 的过期时间, 不然 cookie 的过期时间就是 session 时间, 也就是关闭窗口的时间
      path: '/', // domain 为当前页面 domain
    });
    // $i18n.setLang('en-US');
    // return 'zh-CN';
    return defaultLang(window.location.host);
  }
  return Cookie.get('giwsLang');
}

export { setLocale, getLocale };
